import { axios } from '@/utils/request'
import ipConfig from '../../config/ip.config'
export const api = {
  getInOutTicketStatisticUrl: ipConfig.api_wms_report + '/UserCenter/DC/InOutTicketStatistic',
  getInOutTonneStatisticUrl: ipConfig.api_wms_report + '/UserCenter/DC/InOutTonneStatistic',
  getCurrentTonneStockStatisticUrl: ipConfig.api_wms_report + '/UserCenter/DC/CurrentTonneStockStatistic',
  getInOutTicketBarDataUrl: ipConfig.api_wms_report + '/UserCenter/DC/InOutTicketBarData',
  getInOutTonneBarDataUrl: ipConfig.api_wms_report + '/UserCenter/DC/InOutTonneBarData',
  getTonneStockBarDataUrl: ipConfig.api_wms_report + '/UserCenter/DC/TonneStockBarData',
  getSearchInboundDataApiUrl: ipConfig.api_wms_report + '/UserCenter/DC/SearchInboundData',
  exportSearchInboundDataApiUrl: ipConfig.api_wms_report + '/UserCenter/DC/SearchInboundData/Export',
  exportSearchOutboundDataApiUrl: ipConfig.api_wms_report + '/UserCenter/DC/SearchOutboundData/Export',

  exportSearchCFSInboundDataApiUrl: ipConfig.api_wms_report + '/UserCenter/CFS/SearchCFSInboundData/Export',
  exportSearchCFSOutboundDataApiUrl: ipConfig.api_wms_report + '/UserCenter/CFS/SearchCFSOutboundData/Export',

  exportSearchInventoryDataApiUrl: ipConfig.api_wms_report + '/UserCenter/DC/GetSearchInventoryData/Export',
  getSearchOutboundDataUrl: ipConfig.api_wms_report + '/UserCenter/DC/SearchOutboundData',
  getSearchInventoryDataUrl: ipConfig.api_wms_report + '/UserCenter/DC/SearchInventoryData',
  getCFSInboundStatisticUrl: ipConfig.api_wms_report + '/UserCenter/CFS/InboundStatistic',
  getCFSOutboundStatisticUrl: ipConfig.api_wms_report + '/UserCenter/CFS/OutboundStatistic',
  getCFSCurrentCubeStockStatisticUrl: ipConfig.api_wms_report + '/UserCenter/CFS/CurrentCubeStockStatistic',
  getCFSInboundBarDataUrl: ipConfig.api_wms_report + '/UserCenter/CFS/InboundBarData',
  getCFSOutboundContainerBarDataUrl: ipConfig.api_wms_report + '/UserCenter/CFS/OutboundContainerBarData',
  getCFSOutboundTEUBarDataUrl: ipConfig.api_wms_report + '/UserCenter/CFS/OutboundTEUBarData',
  getCFSStockCubeBarDataUrl: ipConfig.api_wms_report + '/UserCenter/CFS/StockCubeBarData',
  getSearchCFSInboundDataUrl: ipConfig.api_wms_report + '/UserCenter/CFS/SearchCFSInboundData',
  getSearchCFSOutboundDataUrl: ipConfig.api_wms_report + '/UserCenter/CFS/SearchCFSOutboundData',
  getCFSInboundPicDataUrl: ipConfig.api_wms_report + '/UserCenter/CFS/GetCFSInboundPicSearchList',
  getCFSOutboundPicDataUrl: ipConfig.api_wms_report + '/UserCenter/CFS/GetCFSOutboundPicSearchList',
  getCFSCTNPicDataUrl: ipConfig.api_wms_report + '/UserCenter/CFS/GetCFSCTNPicSearchData',
  getCFSDownLoadPicDataUrl: ipConfig.api_wms_report + '/UserCenter/CFS/ExportZIP',
  getCFSOutDownLoadPicDataUrl: ipConfig.api_wms_report + '/UserCenter/CFS/ExportOutboundZIP',
  getWarehouseDataUrl: ipConfig.api_wms_report + '/UserCenter/WMS/GetWarehouse',
  getGetMilestoneDetailUrl: ipConfig.api_wms_report + '/UserCenter/WMS/GetMilestoneDetail',
}

export function getInOutTicketStatisticApi(params) {
  return axios({
    url: api.getInOutTicketStatisticUrl,
    method: 'get',
    params
  })
}

export function getInOutTonneStatisticApi(params) {
  return axios({
    url: api.getInOutTonneStatisticUrl,
    method: 'get',
    params
  })
}

export function getCurrentTonneStockStaticApi(params) {
  return axios({
    url: api.getCurrentTonneStockStatisticUrl,
    method: 'get',
    params
  })
}

export function getInOutTicketBarDataApi(params) {
  return axios({
    url: api.getInOutTicketBarDataUrl,
    method: 'get',
    params
  })
}

export function getInOutTonneBarDataApi(params) {
  return axios({
    url: api.getInOutTonneBarDataUrl,
    method: 'get',
    params
  })
}

export function getTonneStockBarDataApi(params) {
  return axios({
    url: api.getTonneStockBarDataUrl,
    method: 'get',
    params
  })
}

// DC入库查询
export function getSearchInboundDataApi(params) {
  return axios({
    url: api.getSearchInboundDataApiUrl,
    method: 'get',
    params
  })
}

export function exportSearchOutboundDataApi(params) {
  return axios({
    url: api.exportSearchOutboundDataApiUrl,
    method: 'get',
    params,
    responseType: 'blob'
  })
}
export function exportSearchInboundDataApi(params) {
  return axios({
    url: api.exportSearchInboundDataApiUrl,
    method: 'get',
    params,
    responseType: 'blob'
  })
}
export function getSearchOutboundDataApi(params) {
  return axios({
    url: api.getSearchOutboundDataUrl,
    method: 'get',
    params
  })
}
export function getSearchInventoryDataApi(params) {
  return axios({
    url: api.getSearchInventoryDataUrl,
    method: 'get',
    params
  })
}

export function getCFSInboundStatisticApi(params) {
  return axios({
    url: api.getCFSInboundStatisticUrl,
    method: 'get',
    params
  })
}

export function getCFSOutboundStatisticApi(params) {
  return axios({
    url: api.getCFSOutboundStatisticUrl,
    method: 'get',
    params
  })
}

export function getCFSCurrentCubeStockStatisticApi(params) {
  return axios({
    url: api.getCFSCurrentCubeStockStatisticUrl,
    method: 'get',
    params
  })
}

export function getCFSInboundBarDataApi(params) {
  return axios({
    url: api.getCFSInboundBarDataUrl,
    method: 'get',
    params
  })
}

export function getCFSOutboundContainerBarDataApi(params) {
  return axios({
    url: api.getCFSOutboundContainerBarDataUrl,
    method: 'get',
    params
  })
}

export function getCFSOutboundTEUBarDataApi(params) {
  return axios({
    url: api.getCFSOutboundTEUBarDataUrl,
    method: 'get',
    params
  })
}

export function getCFSStockCubeBarDataApi(params) {
  return axios({
    url: api.getCFSStockCubeBarDataUrl,
    method: 'get',
    params
  })
}

export function getSearchCFSInboundDataApi(params) {
  return axios({
    url: api.getSearchCFSInboundDataUrl,
    method: 'get',
    params
  })
}

export function getSearchCFSOutboundDataApi(params) {
  return axios({
    url: api.getSearchCFSOutboundDataUrl,
    method: 'get',
    params
  })
}

export function getCFSInboundPicDataApi(params) {
  return axios({
    url: api.getCFSInboundPicDataUrl,
    method: 'get',
    params
  })
}

export function getCFSOutboundPicDataApi(params) {
  return axios({
    url: api.getCFSOutboundPicDataUrl,
    method: 'get',
    params
  })
}
export function getCFSCTNPicDataApi(params) {
  return axios({
    url: api.getCFSCTNPicDataUrl,
    method: 'get',
    params
  })
}
export function getCFSDownLoadPicDataApi(params) {
  return axios({
    url: api.getCFSDownLoadPicDataUrl,
    method: 'get',
    params
  })
}
export function getCFSOutDownLoadPicDataApi(params) {
  return axios({
    url: api.getCFSOutDownLoadPicDataUrl,
    method: 'get',
    params
  })
}
export function getWarehouseDataApi(params) {
  return axios({
    url: api.getWarehouseDataUrl,
    method: 'get',
    params
  })
}
export function getGetMilestoneDetailApi(params) {
  return axios({
    url: api.getGetMilestoneDetailUrl,
    method: 'get',
    params
  })
}
